/* eslint-disable no-bitwise */
import * as React from "react";
import * as Survey from "survey-react";

import { PersonRequest } from "@plinknz/tah-website-elements";

import { BenefitForm } from "./benefit-form";
import { BenefitType } from "../../../config/forms";
import { CustomerFormQuestionTypes } from "./customer-form-types";
import { createSurveyConfig } from "../../../service/forms/cultural-survey-config";
import { transformBenefitFormData } from "../../../utility/form-transforms/transform-benefit-form-data";

export const CulturalGrantForm = () => {
    const transformData = (
        survey: Survey.ReactSurveyModel,
        member: PersonRequest
    ) => {
        return transformBenefitFormData(
            survey,
            member,
            BenefitType.CulturalGrant
        );
    };

    return (
        <BenefitForm
            createSurveyConfig={createSurveyConfig}
            transformData={transformData}
            questionTypes={
                CustomerFormQuestionTypes.AddressFinder |
                CustomerFormQuestionTypes.BankAccount |
                CustomerFormQuestionTypes.FileUpload
            }
        />
    );
};
